import { Tooltip } from "@mui/material";
import { capitalize } from "lodash";
import StatusChip from "../../../../../components/StatusChip";
import { replaceUnderScoreAddSpace } from "../../../../../utils/utils";
import {
  DEFAULT_SUPER_BILL_STATUS_VARIANT,
  SUPER_BILL_STATUS_LABEL_MAP,
  SUPER_BILL_STATUS_VARIANT_MAP,
} from "../billing-constant";

interface InvoiceStatusChipProps {
  /** Raw superBillStatus from the API, e.g. "OVERDUE". */
  status?: string | null;
  /** Shown on hover, e.g. the cancel reason or an applied discount. */
  tooltip?: string;
  /** Rendered when there is no status. */
  fallback?: string;
}

/**
 * Invoice status chip shared by Billing -> Invoices and Patient Chart ->
 * Financials -> Invoices so both tables use the same label, colour and
 * visual priority for a given status.
 */
const InvoiceStatusChip = ({
  status,
  tooltip,
  fallback = "-",
}: InvoiceStatusChipProps) => {
  if (!status) return <>{fallback}</>;

  const label =
    SUPER_BILL_STATUS_LABEL_MAP[status] ??
    capitalize(replaceUnderScoreAddSpace(status));

  return (
    <Tooltip title={tooltip || ""}>
      <div>
        <StatusChip
          label={label}
          variant={
            SUPER_BILL_STATUS_VARIANT_MAP[status] ??
            DEFAULT_SUPER_BILL_STATUS_VARIANT
          }
        />
      </div>
    </Tooltip>
  );
};

export default InvoiceStatusChip;
